import { cygnusIconElement } from '@root/services/cygnusIconMarkup';

export default function (elements, clearField) {
  elements.forEach((input) => {
    function createIcon() {
      function handleClick(e) {
        e.stopPropagation();
        if (input.value) {
          const field = icon.closest('.tabulator-col')?.getAttribute('tabulator-field');
          if (field) {
            clearField(field)
          }
        }
      }

      // Built as a raw SVG (not a <CygnusIcon> Vue instance) because this
      // icon is injected imperatively into Tabulator's own column-header DOM,
      // outside Vue's render tree. 'x' = Cygnus name for the legacy
      // 'times'/'xmark' glyph.
      const icon = cygnusIconElement('x');
      icon.style.position = 'absolute';
      icon.style.right = '5px';
      icon.style.top = '50%';
      icon.style.transform = 'translateY(-50%)';
      icon.style.cursor = 'pointer';
      icon.addEventListener('click', handleClick);

      return icon;
    }

    const icon = createIcon();
    const parent = input.parentElement;

    parent.style.position = 'relative';
    parent.appendChild(icon);

    input.type = 'text';
  })
}
